
import { Name } from "./name";
import { OptionMenu } from "./option-menu";

class MartialStatusMenu extends OptionMenu {
  constructor(name)  {
    super(name, [
      new Name("single", "Single"),
      new Name("married", "Married"),
      new Name("divorced", "Divorced"),
      new Name("domesticPartner", "Domestic Partner"),
      new Name("widowed", "Widowed"),
    ]);
  }
}

export { MartialStatusMenu };
